import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import { VirtualRoomRouterStoreSelectors } from '@era/stores';
import * as fromFanspeed from './fanspeed.reducer';

export interface FanspeedState {
  fanspeeds: fromFanspeed.FanspeedState;
}

export const reducers: ActionReducerMap<FanspeedState> = {
  fanspeeds: fromFanspeed.fanspeedReducer,
};

export const selectFanspeedState = createFeatureSelector<fromFanspeed.FanspeedState>(
  fromFanspeed.inRoomFanspeedFeatureKey
);

export const selectFanspeedIds = createSelector(selectFanspeedState, fromFanspeed.selectFanspeedIds);

export const selectFanspeedEntities = createSelector(selectFanspeedState, fromFanspeed.selectFanspeedEntities);

export const selectAllFanspeeds = createSelector(selectFanspeedState, fromFanspeed.selectAllFanspeeds);

export const selectFanspeedTotal = createSelector(selectFanspeedState, fromFanspeed.selectFanspeedTotal);

export const selectCurrentFanspeed = createSelector(
  selectFanspeedEntities,
  VirtualRoomRouterStoreSelectors.selectLocation,
  VirtualRoomRouterStoreSelectors.selectRoom,
  (entities, location: string, room: string) => {
    return entities[fromFanspeed.selectFanspeedId(location, room)];
  }
);
